import type { MessageDescriptor } from 'react-intl';
import type { DefaultMessages } from '~/i18n/types';
import Logger from '~/utils/logger/logger';

class I18nLoader {
  private messages: DefaultMessages | undefined;

  get = (id: keyof DefaultMessages | string): MessageDescriptor | undefined => {
    return this.messages ? this.messages[id] : undefined;
  };

  getWithDefault = (id: keyof DefaultMessages | string): MessageDescriptor => {
    const msg = this.get(id);
    return msg ? msg : { id };
  };

  fetchMessages = async () => {
    try {
      const messages: DefaultMessages = (await import('~/i18n/info-messages'))
        .default;

      Logger.log(
        'Loaded default messages. Number of messages:',
        Object.keys(messages).length
      );

      this.setMessages(messages);
      return this.messages;
    } catch (error) {
      Logger.error('Failed to load chunk with translations:');
      Logger.error(error);
    }
  };

  setMessages = (messages: DefaultMessages | undefined) => {
    this.messages = messages;
  };
}

export default new I18nLoader();
